//DB call for Dashboard Cards
export const GetTelerikReportCards = () => {
  let projectionCards = [
    {
      myorder: 1,
      Product: "REPORT",
      Text1: "Product Sales",
      Text2: "",
      TileColor: "purple",
      Score: "",
      Score_Color: "green darken-1",
      Icon: "shopping-cart",
      Icon_Title: "",
      Drill_Down: "true",
      Drill_Component: "",
      Title: "REPORT",
      RouterPath: "TelerikReport/Samples/Product Sales"
    },
    {
      myorder: 2,
      Product: "REPORT",
      Text1: "Dashboard",
      Text2: "",
      TileColor: "orange",
      Score: "",
      Score_Color: "red darken-1",
      Icon: "newspaper",
      Icon_Title: "",
      Drill_Down: "true",
      Drill_Component: "",
      Title: "REPORT",
      RouterPath: "TelerikReport/Samples/Dashboard"
    }
  ];
  return projectionCards;
};


import axios from "axios";
import { baseUrl } from "../../config/app.config.js";

export const getReports = async() => {
    
    return await axios.get(
      baseUrl +
        "/api/Reports/GetAllReportsTypes"
    );
  };